import React, { PureComponent, ReactNode } from "react";
import styled from "styled-components";

import { translate } from "../../../../../../../services/translation.service";
import { media } from "../../../../../../../theme";
import LinksList from "../LinksList";
import SectionFooter from "../SectionFooter";

import { aboutLinksDictionary } from "./aboutLinksDictionary";

const StyledLinksList = styled(LinksList)`
  margin-top: 21px;

  ${media.laptop} {
    margin-top: 0;
  }
`;

export default class AboutSection extends PureComponent<{}> {
  public render(): ReactNode {
    return (
      <SectionFooter title={translate("footer.aboutUs")}>
        <StyledLinksList linksList={aboutLinksDictionary} />
      </SectionFooter>
    );
  }
}
